import { calculateFileSize } from '@pba/react-utils';
import type { UploadedFile } from 'models';
import { useTranslation } from 'react-i18next';
import { Attachments as AttachmentsUI, Text } from 'ui';
import { SaveAttachmentsAsZipButton } from './save-attachments-as-zip-button';
import { SaveSingleAttachmentButton } from './save-single-attachment-button';

type P = {
  attachments: UploadedFile[];
};

const Attachments = ({ attachments }: P) => {
  const { t } = useTranslation();

  return (
    <AttachmentsUI
      attachments={attachments.map((file) => ({
        ...file,
        byteSize: calculateFileSize(file.byteSize),
        extra: <SaveSingleAttachmentButton attachment={file} />,
      }))}
      extra={<SaveAttachmentsAsZipButton attachments={attachments} />}
      title={<Text weight="medium">{t('Attachments ({{count}})', { count: attachments.length })}</Text>}
    />
  );
};

export default Attachments;
